import getPreviousMonthDates from './getPreviousMonthDates';
export default getPreviousMonthDates;
